import { render, staticRenderFns } from "./commonSidebar.vue?vue&type=template&id=b98be086&scoped=true"
import script from "./commonSidebar.vue?vue&type=script&lang=js"
export * from "./commonSidebar.vue?vue&type=script&lang=js"
import style0 from "./commonSidebar.vue?vue&type=style&index=0&id=b98be086&prod&lang=css"
import style1 from "./commonSidebar.vue?vue&type=style&index=1&id=b98be086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98be086",
  null
  
)

export default component.exports